



































































































import Vue from "vue";
import { Component,  Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import FileUpload from '../../Workspace/Components/FileUpload.vue';
import HeaderInfo from '@/components/App/Modules/GMS/Grants/ExpansionPanel/ExpansionPanel.vue';

@Component({
    components: {
        FileUpload,
        HeaderInfo
    }
})
export default class GrantDocs extends Vue {
    @Getter("readGrant", { namespace: "grant" }) grant: any;
    @Prop() grantId: number;

    search: string = '';
    documents: any = [];
    headers: any = [];
    dialog: boolean = false;
    doc: any = {};
    docTags: any = [];
    actions = _app.actions;
    subjects = _app.subjects;

    /** mounted fn */
    mounted() {
        this.headers = _app.docHeaders;
        this.headers.map(x => {
            x.text = this.$t(x.text);
        });

        this.list();
    }

    /** Document list */
    list() {
        this.$services.document.listDocs(_app.menu.grant, this.grantId)
        .then((resp: any) => {
            if(resp.Result === 'OK') {
                // fill the docTag dropdowns;
                this.documents = resp.Record;
                if(resp.DocumentTagId && resp.DocumentTagId.Result) {
                    const { Value } = resp.DocumentTagId.Result;
                    if(Value) {
                        this.docTags = Value.Record || {};
                    }
                }
            }
        });
    }

    /** delete a document */
    deleteItem(item: any) {
        this.$services.document.removeDocument({
            documentId: item.DocumentStoreId,
            uploadedFileName: item.UploadedName
        }).then((finish: any) => {
            if(finish) {
                this.list();
            }
        });
    }

    /** download the file */
    download(doc) {
        this.$services.document.download({
            documentId: doc.DocumentStoreId,
            uploadedFileName: doc.UploadedName
        })
    }

    /*** method to add files */
    onAddFiles(e, doc) {
        const {name, type, size} = e;
        this.$services.document.uploadDocument(e, {
             options: { 
                 docTag: doc.docType,
                 menu: _app.menu.grant  
                 } 
             }, this.grantId, this.$vuetify.lang.current)
        .then((data) => {
            this.dialog = false;
            this.$services.document.listDocs(_app.menu.grant, this.grantId)
            .then((resp: any) => {
                if(resp.Result === 'OK') {
                    this.documents = resp.Record;
                }
            });
            // console.log(data);
        });              
    }

    checkPermission(btn: string) {
        switch(btn) {
            case 'add': {
                //@ts-ignore
                if(this.$can(this.actions.update, this.subjects.grantDocs))
                    return true;
            }
            break;
            case 'delete': {
                //@ts-ignore
                if(this.$can(this.actions.update, this.subjects.grantDocs))
                    return true;
            }
        }
    }
    
}
